import React, { useEffect } from "react";
import { CheckCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

const SuccessModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        onClose();
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <>
      {/* Inline animation styles */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes pop {
          0% { transform: scale(0.5); opacity: 0; }
          80% { transform: scale(1.1); opacity: 1; }
          100% { transform: scale(1); }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }
        .animate-pop {
          animation: pop 0.4s ease-out;
        }
        .progress-line {
          animation: grow 2s linear forwards;
        }
        @keyframes grow {
          from { width: 0%; }
          to { width: 100%; }
        }
      `}</style>

      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 animate-fadeIn">
        <div className="relative w-full max-w-md p-8 text-center bg-white rounded-lg shadow-lg">
          {/* Close Button */}
          <button
            onClick={onClose}
            className="absolute text-gray-600 top-4 right-4 hover:text-black"
          >
            <XMarkIcon className="w-6 h-6" />
          </button>

          {/* Success Icon */}
          <div className="flex justify-center mb-4">
            <CheckCircleIcon className="w-16 h-16 text-green-500 animate-pop" />
          </div>

          {/* Message */}
          <h2 className="mb-2 text-2xl font-bold text-black">
            {t("commentAddedTitle")}
          </h2>
          {/* <p className="mb-6 text-gray-700">{t("commentAddedMessage")}</p> */}

          {/* Progress Line */}
          <div className="w-full h-1 overflow-hidden bg-gray-200 rounded">
            <div className="h-full bg-custom-yellow progress-line"></div>
          </div>

          {/* Button */}
          <button
            onClick={onClose}
            className="w-full px-4 py-2 mt-6 text-black transition-colors rounded-lg bg-custom-yellow hover:bg-black hover:text-white"
          >
            {t("close")}
          </button>
        </div>
      </div>
    
    </>
  );
};

export default SuccessModal;
